import axiosInstance from 'utils/axiosInstance';
import {
  OpayPaymentPayload,
  OpayPaymentResponse,
  OpayStatusResponse,
} from './types';

export class OpayHandler {
  async initiatePayment(payload: OpayPaymentPayload): Promise<OpayPaymentResponse> {
    const response = await axiosInstance.post('/opay/payment', payload);
    return response.data;
  }

  async getStatus(referenceId: string): Promise<OpayStatusResponse> {
    const response = await axiosInstance.get(`/opay/payment/status/${referenceId}`);
    return response.data;
  }
}
